import styled from 'styled-components';
import media from '../../constants/media';
import theme from '../../constants/theme';
import IconLink from '../base/iconLink';
import { PageContainer } from '../base/pageContainer/pageContainer';
import GrayTextLink from '../grayTextLink';
import LocaleSwitcher from '../localeSwitcher';

export const PageContainerStyled = styled(PageContainer)`
	${media.mobileOnly`
		padding-inline: 0;
	`};
`;

export const FooterContainer = styled.footer`
	margin-top: 150px;
	font-family: ${theme.fonts.Arimo};
	letter-spacing: 0;
`;

export const BackgroundWrapper = styled.div`
	padding-block: 120px 64px;
	background-color: ${theme.colorsV2.grey2};

	${media.tablet`
		border-radius: 8px;
	`};
`;

export const Info = styled.div`
	font-size: 18px;
	font-weight: ${theme.fonts.weight.regular};
	line-height: 1.4;
	color: ${theme.colorsV2.grey6};
`;

export const InfoTitle = styled(Info)`
	font-weight: ${theme.fonts.weight.medium};
`;

export const BaseInfoWrapper = styled.div``;

export const InfoWrapper = styled.div`
	margin-top: 16px;
	${Info} {
		color: ${theme.colorsV2.grey7};
	}
`;

export const Email = styled.a`
	color: ${theme.colorsV2.grey7};
	transition: color 0.2s ease;

	&:hover {
		color: ${theme.colorsV2.mainRed};
	}
`;

export const GeneralInfo = styled.div`
	${media.desktopSmall`
		margin-top: 40px;
	`};
`;

export const LinkTitle = styled.h4`
	margin-block: 22px 16px;
	font-size: 20px;
	font-weight: ${theme.fonts.weight.bold};
	line-height: 1.5;
	color: ${theme.colorsV2.grey8};

	${media.desktopSmall`
		margin-bottom: 24px;
	`};
`;

export const LinkWrapper = styled.div``;

export const Link = styled(GrayTextLink)`
	margin-top: 24px;
	line-height: 1.3;
	color: ${theme.colorsV2.grey7};
	font-size: 18px;

	${media.desktopSmall`
		margin-top: 16px;
	`};
`;

export const SocialLink = styled(IconLink)`
	margin-top: 24px;
	margin-left: 24px;
	height: 24px;

	svg {
		height: 100%;
		width: auto;
	}

	${media.desktopSmall`
		margin-top: 16px;
	`};
`;

export const SocialLinks = styled.div`
	display: flex;
	flex-wrap: wrap;
	margin-left: -24px;
`;

export const LocaleCertificationWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 16px;

	${media.tablet`
		padding: 16px 8px;
	`};
`;

export const Certifications = styled.div`
	display: flex;
	margin-left: -24px;
`;

export const CertificationLink = styled(IconLink)`
	margin-left: 24px;
	height: 32px;

	${media.desktopSmall`
		height: 47px;
	`};

	svg {
		height: 100%;
		width: auto;
	}
`;

export const LocaleWrapper = styled.div`
	display: flex;
	align-items: center;
`;

export const LanguageSwitch = styled(LocaleSwitcher)`
	margin-left: 12px;
`;
